import { combineReducers } from 'redux';
import { teamsListReducer } from './teams-list/teams-list.reducer';
import { teamDetailsReducer } from './team-details/team-details.reducer';
import { addTeamReducer } from './add-team/add-team.reducer';
import { permissionsReducer } from './permissions/permissions.reducer';
import { editTeamReducer } from './edit-team/edit-team.reducer';
import { jurisdictionsReducer } from './jurisdictions/jurisdictions.reducer';

export const teamsReducer = combineReducers({
    list: teamsListReducer,
    details: teamDetailsReducer,
    addUser: addTeamReducer,
    editTeam: editTeamReducer,
    permissions: permissionsReducer,
    jurisdictions: jurisdictionsReducer
});
